export const iconFontAwesomeSportsFitnessWeightHanging = (
	<i className="fa-solid fa-weight-hanging"></i>
);
